import React from 'react';
import { useEmployeeService } from 'domain/shared/employee';
import { FormShowTemplate, DEFAULT_ERROR_MESSAGE } from 'framework/form';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';
import IdentityDocumentsContent from '../shared/IdentityDocumentsContent';
import getIdentityDocumentsValidationSchema from '../createupdate/identityDocumentsValidationSchema';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';

const EmployeeIdentityDocumentsSummary: React.FC = () => {
  const { updateIdentityDocuments, getForUpdate } = useEmployeeService();
  const employeeId = useEmployeeId();
  const { addMessage } = useMessageService('employeeIdentityDocuments');

  const handleErrorsOnSubmit = () => {
    addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
  };

  if (!employeeId) {
    return null;
  }

  const handleSubmit = async (values: FormFieldsData): Promise<void | object> => {
    return updateIdentityDocuments(employeeId, values);
  };

  return (
    <FormShowTemplate
      getDataFunc={() => getForUpdate(employeeId)}
      submitFormFunc={handleSubmit}
      getValidationSchemaFunc={getIdentityDocumentsValidationSchema}
      messageContext="employeeIdentityDocuments"
      handleErrorsOnSubmit={handleErrorsOnSubmit}
    >
      <IdentityDocumentsContent />
    </FormShowTemplate>
  );
};

export default EmployeeIdentityDocumentsSummary;
